// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LinkItem-module__font-s-10___Lf_ss {
  font-size: 10px !important;
}

.LinkItem-module__font-s-12___BOg8t {
  font-size: 12px !important;
}

.LinkItem-module__font-s-13___AcC4x {
  font-size: 13px !important;
}

.LinkItem-module__font-s-14___KlX90 {
  font-size: 14px !important;
}

.LinkItem-module__font-s-15___AAMNd {
  font-size: 15px !important;
}

.LinkItem-module__font-s-16___a50dE {
  font-size: 16px !important;
}

.LinkItem-module__font-s-18___mJAKj {
  font-size: 18px !important;
}

.LinkItem-module__font-s-20___tQmBO {
  font-size: 20px !important;
}

.LinkItem-module__font-s-22___ick6q {
  font-size: 22px !important;
}

.LinkItem-module__font-s-28___hgO4G {
  font-size: 28px !important;
}

.LinkItem-module__font-w-400___wvjpv {
  font-weight: 400 !important;
}

.LinkItem-module__font-w-500___bP2pS {
  font-weight: 500 !important;
}

.LinkItem-module__font-w-600___uh15l {
  font-weight: 600 !important;
}

.LinkItem-module__font-w-700___KWAhy {
  font-weight: 700 !important;
}

.LinkItem-module__p-5___AdG0N {
  padding: 5px !important;
}

.LinkItem-module__p-12___kVxB4 {
  padding: 12px !important;
}

.LinkItem-module__p-16___F4qpM {
  padding: 16px !important;
}

.LinkItem-module__p-30___I5PkK {
  padding: 30px !important;
}

.LinkItem-module__p-b-0___TP_qT {
  padding-bottom: 0 !important;
}

.LinkItem-module__p-b-5___rR5ss {
  padding-bottom: 5px !important;
}

.LinkItem-module__p-b-10___l4SVg {
  padding-bottom: 10px !important;
}

.LinkItem-module__p-b-12___h9PAQ {
  padding-bottom: 12px !important;
}

.LinkItem-module__p-b-16___u14sE {
  padding-bottom: 16px !important;
}

.LinkItem-module__p-b-18___VKjVw {
  padding-bottom: 18px !important;
}

.LinkItem-module__p-b-20___gAseS {
  padding-bottom: 20px !important;
}

.LinkItem-module__p-b-25___xsgGp {
  padding-bottom: 25px !important;
}

.LinkItem-module__p-b-30___U3TxJ {
  padding-bottom: 30px !important;
}

.LinkItem-module__p-b-50___KZQSG {
  padding-bottom: 50px !important;
}

.LinkItem-module__p-t-0___VwOeD {
  padding-top: 0 !important;
}

.LinkItem-module__p-t-12___mr4sP {
  padding-top: 12px !important;
}

.LinkItem-module__p-t-16___LIl5x {
  padding-top: 16px !important;
}

.LinkItem-module__p-t-18___Yb76G {
  padding-top: 18px !important;
}

.LinkItem-module__p-t-20___i0pXm {
  padding-top: 20px !important;
}

.LinkItem-module__p-t-30___ZPTry {
  padding-top: 30px !important;
}

.LinkItem-module__p-t-40___foJk7 {
  padding-top: 40px !important;
}

.LinkItem-module__p-t-50____Re4u {
  padding-top: 50px !important;
}

.LinkItem-module__p-l-20___1WYaQ {
  padding-left: 20px !important;
}

.LinkItem-module__p-l-30___GVhPt {
  padding-left: 30px !important;
}

.LinkItem-module__p-l-40___XR7bH {
  padding-left: 40px !important;
}

.LinkItem-module__p-r-16___Hw2fy {
  padding-right: 16px !important;
}

.LinkItem-module__p-r-20___ofgrW {
  padding-right: 20px !important;
}

.LinkItem-module__p-r-30___b8EU2 {
  padding-right: 30px !important;
}

.LinkItem-module__p-r-50___H7VVY {
  padding-right: 50px !important;
}

.LinkItem-module__p-r-60___dFVcW {
  padding-right: 60px !important;
}

.LinkItem-module__m-b-1___A7XSq {
  margin-bottom: 1px !important;
}

.LinkItem-module__m-b-2___pSAAv {
  margin-bottom: 2px !important;
}

.LinkItem-module__m-b-6___ogVQo {
  margin-bottom: 6px !important;
}

.LinkItem-module__m-b-8___himCQ {
  margin-bottom: 8px !important;
}

.LinkItem-module__m-b-10___riNDI {
  margin-bottom: 10px !important;
}

.LinkItem-module__m-b-14___N0XWl {
  margin-bottom: 14px !important;
}

.LinkItem-module__m-b-16___bjnP0 {
  margin-bottom: 16px !important;
}

.LinkItem-module__m-b-20___PM3kd {
  margin-bottom: 20px !important;
}

.LinkItem-module__m-b-22___kcPdO {
  margin-bottom: 22px !important;
}

.LinkItem-module__m-b-24___WiPlI {
  margin-bottom: 24px !important;
}

.LinkItem-module__m-b-30___t7IGP {
  margin-bottom: 30px !important;
}

.LinkItem-module__m-b-32___pJDO_ {
  margin-bottom: 32px !important;
}

.LinkItem-module__m-b-40___Xtslj {
  margin-bottom: 40px !important;
}

.LinkItem-module__m-t-2___ey1aK {
  margin-top: 2px !important;
}

.LinkItem-module__m-t-3___qPeLD {
  margin-top: 3px !important;
}

.LinkItem-module__m-t-4___DIsqi {
  margin-top: 4px !important;
}

.LinkItem-module__m-t-5___B4ijN {
  margin-top: 5px !important;
}

.LinkItem-module__m-t-8___EWIYk {
  margin-top: 8px !important;
}

.LinkItem-module__m-t-10___Wfak5 {
  margin-top: 10px !important;
}

.LinkItem-module__m-t-15___KieD6 {
  margin-top: 15px !important;
}

.LinkItem-module__m-t-16___keH7O {
  margin-top: 16px !important;
}

.LinkItem-module__m-t-20___YE171 {
  margin-top: 20px !important;
}

.LinkItem-module__m-t-22___Hqwc9 {
  margin-top: 22px !important;
}

.LinkItem-module__m-t-30___leNdd {
  margin-top: 30px !important;
}

.LinkItem-module__m-t-32___HeZm5 {
  margin-top: 32px !important;
}

.LinkItem-module__m-l-auto___pQUid {
  margin-left: auto !important;
}

.LinkItem-module__m-l-4___zW1V3 {
  margin-left: 4px !important;
}

.LinkItem-module__m-l-5___bbz0P {
  margin-left: 5px !important;
}

.LinkItem-module__m-l-6___iEfLo {
  margin-left: 6px !important;
}

.LinkItem-module__m-l-8___Y9Df3 {
  margin-left: 8px !important;
}

.LinkItem-module__m-l-10___MJ4kV {
  margin-left: 10px !important;
}

.LinkItem-module__m-l-16___CKy_T {
  margin-left: 16px !important;
}

.LinkItem-module__m-l-20___J0Ud1 {
  margin-left: 20px !important;
}

.LinkItem-module__m-l-24___MVp27 {
  margin-left: 24px !important;
}

.LinkItem-module__m-l-30___LvYsY {
  margin-left: 30px !important;
}

.LinkItem-module__m-l-35___paFEu {
  margin-left: 35px !important;
}

.LinkItem-module__m-l-40___FhYs4 {
  margin-left: 40px !important;
}

.LinkItem-module__m-r-8___gaJiH {
  margin-right: 8px !important;
}

.LinkItem-module__m-r-10___H7Thx {
  margin-right: 10px !important;
}

.LinkItem-module__m-r-16___OInkz {
  margin-right: 16px !important;
}

.LinkItem-module__m-r-20___V9PYO {
  margin-right: 20px !important;
}

.LinkItem-module__m-r-24___rbGMG {
  margin-right: 24px !important;
}

.LinkItem-module__m-r-30___KKEVX {
  margin-right: 30px !important;
}

.LinkItem-module__m-r-40___iL7p4 {
  margin-right: 40px !important;
}

.LinkItem-module__border-r-3___VEmS0 {
  border-radius: 3px !important;
}

.LinkItem-module__border-r-4___DZzSx {
  border-radius: 4px !important;
}

.LinkItem-module__border-r-6____clbO {
  border-radius: 6px !important;
}

.LinkItem-module__border-r-10___UV5iG {
  border-radius: 10px !important;
}

.LinkItem-module__border-r-12___ZeNH6 {
  border-radius: 12px !important;
}

.LinkItem-module__border-r-16___nkiGk {
  border-radius: 16px !important;
}

.LinkItem-module__border-r-50___h02ct {
  border-radius: 50% !important;
}

.LinkItem-module__primary-border___RK19O {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-b___mDUsB {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-t____KFrf {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-l___Muzer {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__primary-border-r___ZpBSy {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.LinkItem-module__secondary-border___UaWqz {
  border: 1px solid #637768;
}

.LinkItem-module__secondary-border-b___vgHBE {
  border-bottom: 1px solid #637768;
}

.LinkItem-module__secondary-border-t___wFQBS {
  border-top: 1px solid #637768;
}

.LinkItem-module__secondary-border-l___gt6Cg {
  border-left: 1px solid #637768;
}

.LinkItem-module__secondary-border-r___w0a0a {
  border-right: 1px solid #637768;
}

.LinkItem-module__gap-0___j1RnE {
  gap: 0 !important;
}

.LinkItem-module__gap-2___YUved {
  gap: 2px !important;
}

.LinkItem-module__gap-4___WmPk1 {
  gap: 4px !important;
}

.LinkItem-module__gap-5___gIyXg {
  gap: 5px !important;
}

.LinkItem-module__gap-6___DkGdf {
  gap: 6px !important;
}

.LinkItem-module__gap-8___NfcwS {
  gap: 8px !important;
}

.LinkItem-module__gap-10___RuE9t {
  gap: 10px !important;
}

.LinkItem-module__gap-12___g1GuM {
  gap: 12px !important;
}

.LinkItem-module__gap-14___CT60g {
  gap: 14px !important;
}

.LinkItem-module__gap-16___Daegd {
  gap: 16px !important;
}

.LinkItem-module__gap-18___TmNMS {
  gap: 18px !important;
}

.LinkItem-module__gap-20___X7fj2 {
  gap: 20px !important;
}

.LinkItem-module__gap-24___gOk35 {
  gap: 24px !important;
}

.LinkItem-module__gap-26___FoE9f {
  gap: 26px !important;
}

.LinkItem-module__gap-30___X5Nli {
  gap: 30px !important;
}

.LinkItem-module__gap-32___jTqQk {
  gap: 32px !important;
}

.LinkItem-module__gap-40____H1tL {
  gap: 40px !important;
}

.LinkItem-module__gap-50___p0wYp {
  gap: 50px !important;
}

.LinkItem-module__flex-1___ljNmo {
  flex: 1;
}

.LinkItem-module__flex-none___SsS7u {
  flex: none !important;
}

.LinkItem-module__flex-column___ZWLFS {
  display: flex;
  flex-direction: column !important;
}

.LinkItem-module__flex-row___qk54g {
  display: flex;
  flex-direction: row !important;
}

.LinkItem-module__vertically-centered___IHp5M {
  display: flex;
  align-items: center !important;
}

.LinkItem-module__horizontally-centered___p5SdY {
  display: flex;
  justify-content: center !important;
}

.LinkItem-module__horizontally-end___NyRiK {
  display: flex;
  justify-content: end !important;
}

.LinkItem-module__vertically-start___HJvBw {
  display: flex;
  align-items: start !important;
}

.LinkItem-module__space-between___Zddca {
  display: flex;
  justify-content: space-between !important;
}

.LinkItem-module__flex-wrap___N0JO8 {
  flex-wrap: wrap !important;
}

.LinkItem-module__height-100___CAnlD {
  height: 100%;
}

.LinkItem-module__width-50___A3EsP {
  width: 50% !important;
}

.LinkItem-module__width-100___rpbeR {
  width: 100%;
}

.LinkItem-module__cursor-pointer___Jxyeh {
  cursor: pointer;
}

.LinkItem-module__cursor-not-allowed___W0e7U {
  cursor: not-allowed !important;
}

.LinkItem-module__absolute-centered___h40Sk {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.LinkItem-module__absolute___etur5 {
  position: absolute;
}

.LinkItem-module__relative___Prgen {
  position: relative;
}

.LinkItem-module__fixed___O2cqT {
  position: fixed;
}

.LinkItem-module__visible___Eddud {
  opacity: 1;
}

.LinkItem-module__invisible___lh3bc {
  opacity: 0;
}

.LinkItem-module__col-90___ys6bC {
  width: 90% !important;
}

.LinkItem-module__col-auto___MSUan {
  width: auto !important;
}

.LinkItem-module__medical-tabs___gAvn6 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.LinkItem-module__medical-table-new___vFj6C {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LinkItem-module__medical-table-new___vFj6C:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LinkItem-module__medical-table-new___vFj6C::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LinkItem-module__medical-table-new___vFj6C::-webkit-scrollbar-track {
  display: none;
}
.LinkItem-module__medical-table-new___vFj6C.LinkItem-module__no-pagination___CPZGJ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.LinkItem-module__medical-table-new___vFj6C.LinkItem-module__no-pagination___CPZGJ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.LinkItem-module__medical-table-new___vFj6C.LinkItem-module__no-pagination___CPZGJ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.LinkItem-module__medical-table-new___vFj6C.LinkItem-module__no-pagination___CPZGJ::-webkit-scrollbar-track {
  display: none;
}

.LinkItem-module__medical-table-empty___X3rsw {
  padding: 14px 40px !important;
}

.LinkItem-module__icon-btn___Nmk4z {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.LinkItem-module__search-icon___CVTqM {
  width: 24px;
  height: 24px;
  align-self: center;
}

.LinkItem-module__disable-select___Nj33C {
  user-select: none;
}

.LinkItem-module__break-word___ZDDON {
  word-break: break-word;
}

.LinkItem-module__popup-clear-btn___zYApN {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.LinkItem-module__scroll-m-b-20___rU5zb {
  scroll-margin-bottom: 20px;
}

.LinkItem-module__container___sdLpr {
  position: relative;
  height: 100%;
}
.LinkItem-module__container___sdLpr .LinkItem-module__icon___crpBB {
  width: 22px;
  height: 22px;
}
.LinkItem-module__container___sdLpr .LinkItem-module__title___BmZCb {
  color: #375844;
}
.LinkItem-module__container___sdLpr .LinkItem-module__selected___MdnhW {
  height: 4px;
  background-color: #f1bf72;
  position: absolute;
  width: 100%;
  border-radius: 6px 6px 0 0;
  bottom: 2px;
}
.LinkItem-module__container___sdLpr .LinkItem-module__dot___fp0FJ {
  width: 8px;
  height: 8px;
  border-radius: 8px;
  display: inline-block;
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MainFooter/LinkItem/LinkItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;EACA,YAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,cAAA;AA6pBJ;AA1pBE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,WAAA;AA4pBJ;AAzpBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AA2pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  position: relative;\n  height: 100%;\n\n  .icon {\n    width: 22px;\n    height: 22px;\n  }\n\n  .title {\n    color: get-color(greenNew, dark);\n  }\n\n  .selected {\n    height: 4px;\n    background-color: get-color(orangeNew, base);\n    position: absolute;\n    width: 100%;\n    border-radius: 6px 6px 0 0;\n    bottom: 2px;\n  }\n\n  .dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 8px;\n    display: inline-block;\n    margin-left: 4px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `LinkItem-module__font-s-10___Lf_ss`,
	"fontS12": `LinkItem-module__font-s-12___BOg8t`,
	"fontS13": `LinkItem-module__font-s-13___AcC4x`,
	"fontS14": `LinkItem-module__font-s-14___KlX90`,
	"fontS15": `LinkItem-module__font-s-15___AAMNd`,
	"fontS16": `LinkItem-module__font-s-16___a50dE`,
	"fontS18": `LinkItem-module__font-s-18___mJAKj`,
	"fontS20": `LinkItem-module__font-s-20___tQmBO`,
	"fontS22": `LinkItem-module__font-s-22___ick6q`,
	"fontS28": `LinkItem-module__font-s-28___hgO4G`,
	"fontW400": `LinkItem-module__font-w-400___wvjpv`,
	"fontW500": `LinkItem-module__font-w-500___bP2pS`,
	"fontW600": `LinkItem-module__font-w-600___uh15l`,
	"fontW700": `LinkItem-module__font-w-700___KWAhy`,
	"p5": `LinkItem-module__p-5___AdG0N`,
	"p12": `LinkItem-module__p-12___kVxB4`,
	"p16": `LinkItem-module__p-16___F4qpM`,
	"p30": `LinkItem-module__p-30___I5PkK`,
	"pB0": `LinkItem-module__p-b-0___TP_qT`,
	"pB5": `LinkItem-module__p-b-5___rR5ss`,
	"pB10": `LinkItem-module__p-b-10___l4SVg`,
	"pB12": `LinkItem-module__p-b-12___h9PAQ`,
	"pB16": `LinkItem-module__p-b-16___u14sE`,
	"pB18": `LinkItem-module__p-b-18___VKjVw`,
	"pB20": `LinkItem-module__p-b-20___gAseS`,
	"pB25": `LinkItem-module__p-b-25___xsgGp`,
	"pB30": `LinkItem-module__p-b-30___U3TxJ`,
	"pB50": `LinkItem-module__p-b-50___KZQSG`,
	"pT0": `LinkItem-module__p-t-0___VwOeD`,
	"pT12": `LinkItem-module__p-t-12___mr4sP`,
	"pT16": `LinkItem-module__p-t-16___LIl5x`,
	"pT18": `LinkItem-module__p-t-18___Yb76G`,
	"pT20": `LinkItem-module__p-t-20___i0pXm`,
	"pT30": `LinkItem-module__p-t-30___ZPTry`,
	"pT40": `LinkItem-module__p-t-40___foJk7`,
	"pT50": `LinkItem-module__p-t-50____Re4u`,
	"pL20": `LinkItem-module__p-l-20___1WYaQ`,
	"pL30": `LinkItem-module__p-l-30___GVhPt`,
	"pL40": `LinkItem-module__p-l-40___XR7bH`,
	"pR16": `LinkItem-module__p-r-16___Hw2fy`,
	"pR20": `LinkItem-module__p-r-20___ofgrW`,
	"pR30": `LinkItem-module__p-r-30___b8EU2`,
	"pR50": `LinkItem-module__p-r-50___H7VVY`,
	"pR60": `LinkItem-module__p-r-60___dFVcW`,
	"mB1": `LinkItem-module__m-b-1___A7XSq`,
	"mB2": `LinkItem-module__m-b-2___pSAAv`,
	"mB6": `LinkItem-module__m-b-6___ogVQo`,
	"mB8": `LinkItem-module__m-b-8___himCQ`,
	"mB10": `LinkItem-module__m-b-10___riNDI`,
	"mB14": `LinkItem-module__m-b-14___N0XWl`,
	"mB16": `LinkItem-module__m-b-16___bjnP0`,
	"mB20": `LinkItem-module__m-b-20___PM3kd`,
	"mB22": `LinkItem-module__m-b-22___kcPdO`,
	"mB24": `LinkItem-module__m-b-24___WiPlI`,
	"mB30": `LinkItem-module__m-b-30___t7IGP`,
	"mB32": `LinkItem-module__m-b-32___pJDO_`,
	"mB40": `LinkItem-module__m-b-40___Xtslj`,
	"mT2": `LinkItem-module__m-t-2___ey1aK`,
	"mT3": `LinkItem-module__m-t-3___qPeLD`,
	"mT4": `LinkItem-module__m-t-4___DIsqi`,
	"mT5": `LinkItem-module__m-t-5___B4ijN`,
	"mT8": `LinkItem-module__m-t-8___EWIYk`,
	"mT10": `LinkItem-module__m-t-10___Wfak5`,
	"mT15": `LinkItem-module__m-t-15___KieD6`,
	"mT16": `LinkItem-module__m-t-16___keH7O`,
	"mT20": `LinkItem-module__m-t-20___YE171`,
	"mT22": `LinkItem-module__m-t-22___Hqwc9`,
	"mT30": `LinkItem-module__m-t-30___leNdd`,
	"mT32": `LinkItem-module__m-t-32___HeZm5`,
	"mLAuto": `LinkItem-module__m-l-auto___pQUid`,
	"mL4": `LinkItem-module__m-l-4___zW1V3`,
	"mL5": `LinkItem-module__m-l-5___bbz0P`,
	"mL6": `LinkItem-module__m-l-6___iEfLo`,
	"mL8": `LinkItem-module__m-l-8___Y9Df3`,
	"mL10": `LinkItem-module__m-l-10___MJ4kV`,
	"mL16": `LinkItem-module__m-l-16___CKy_T`,
	"mL20": `LinkItem-module__m-l-20___J0Ud1`,
	"mL24": `LinkItem-module__m-l-24___MVp27`,
	"mL30": `LinkItem-module__m-l-30___LvYsY`,
	"mL35": `LinkItem-module__m-l-35___paFEu`,
	"mL40": `LinkItem-module__m-l-40___FhYs4`,
	"mR8": `LinkItem-module__m-r-8___gaJiH`,
	"mR10": `LinkItem-module__m-r-10___H7Thx`,
	"mR16": `LinkItem-module__m-r-16___OInkz`,
	"mR20": `LinkItem-module__m-r-20___V9PYO`,
	"mR24": `LinkItem-module__m-r-24___rbGMG`,
	"mR30": `LinkItem-module__m-r-30___KKEVX`,
	"mR40": `LinkItem-module__m-r-40___iL7p4`,
	"borderR3": `LinkItem-module__border-r-3___VEmS0`,
	"borderR4": `LinkItem-module__border-r-4___DZzSx`,
	"borderR6": `LinkItem-module__border-r-6____clbO`,
	"borderR10": `LinkItem-module__border-r-10___UV5iG`,
	"borderR12": `LinkItem-module__border-r-12___ZeNH6`,
	"borderR16": `LinkItem-module__border-r-16___nkiGk`,
	"borderR50": `LinkItem-module__border-r-50___h02ct`,
	"primaryBorder": `LinkItem-module__primary-border___RK19O`,
	"primaryBorderB": `LinkItem-module__primary-border-b___mDUsB`,
	"primaryBorderT": `LinkItem-module__primary-border-t____KFrf`,
	"primaryBorderL": `LinkItem-module__primary-border-l___Muzer`,
	"primaryBorderR": `LinkItem-module__primary-border-r___ZpBSy`,
	"secondaryBorder": `LinkItem-module__secondary-border___UaWqz`,
	"secondaryBorderB": `LinkItem-module__secondary-border-b___vgHBE`,
	"secondaryBorderT": `LinkItem-module__secondary-border-t___wFQBS`,
	"secondaryBorderL": `LinkItem-module__secondary-border-l___gt6Cg`,
	"secondaryBorderR": `LinkItem-module__secondary-border-r___w0a0a`,
	"gap0": `LinkItem-module__gap-0___j1RnE`,
	"gap2": `LinkItem-module__gap-2___YUved`,
	"gap4": `LinkItem-module__gap-4___WmPk1`,
	"gap5": `LinkItem-module__gap-5___gIyXg`,
	"gap6": `LinkItem-module__gap-6___DkGdf`,
	"gap8": `LinkItem-module__gap-8___NfcwS`,
	"gap10": `LinkItem-module__gap-10___RuE9t`,
	"gap12": `LinkItem-module__gap-12___g1GuM`,
	"gap14": `LinkItem-module__gap-14___CT60g`,
	"gap16": `LinkItem-module__gap-16___Daegd`,
	"gap18": `LinkItem-module__gap-18___TmNMS`,
	"gap20": `LinkItem-module__gap-20___X7fj2`,
	"gap24": `LinkItem-module__gap-24___gOk35`,
	"gap26": `LinkItem-module__gap-26___FoE9f`,
	"gap30": `LinkItem-module__gap-30___X5Nli`,
	"gap32": `LinkItem-module__gap-32___jTqQk`,
	"gap40": `LinkItem-module__gap-40____H1tL`,
	"gap50": `LinkItem-module__gap-50___p0wYp`,
	"flex1": `LinkItem-module__flex-1___ljNmo`,
	"flexNone": `LinkItem-module__flex-none___SsS7u`,
	"flexColumn": `LinkItem-module__flex-column___ZWLFS`,
	"flexRow": `LinkItem-module__flex-row___qk54g`,
	"verticallyCentered": `LinkItem-module__vertically-centered___IHp5M`,
	"horizontallyCentered": `LinkItem-module__horizontally-centered___p5SdY`,
	"horizontallyEnd": `LinkItem-module__horizontally-end___NyRiK`,
	"verticallyStart": `LinkItem-module__vertically-start___HJvBw`,
	"spaceBetween": `LinkItem-module__space-between___Zddca`,
	"flexWrap": `LinkItem-module__flex-wrap___N0JO8`,
	"height100": `LinkItem-module__height-100___CAnlD`,
	"width50": `LinkItem-module__width-50___A3EsP`,
	"width100": `LinkItem-module__width-100___rpbeR`,
	"cursorPointer": `LinkItem-module__cursor-pointer___Jxyeh`,
	"cursorNotAllowed": `LinkItem-module__cursor-not-allowed___W0e7U`,
	"absoluteCentered": `LinkItem-module__absolute-centered___h40Sk`,
	"absolute": `LinkItem-module__absolute___etur5`,
	"relative": `LinkItem-module__relative___Prgen`,
	"fixed": `LinkItem-module__fixed___O2cqT`,
	"visible": `LinkItem-module__visible___Eddud`,
	"invisible": `LinkItem-module__invisible___lh3bc`,
	"col90": `LinkItem-module__col-90___ys6bC`,
	"colAuto": `LinkItem-module__col-auto___MSUan`,
	"medicalTabs": `LinkItem-module__medical-tabs___gAvn6`,
	"medicalTableNew": `LinkItem-module__medical-table-new___vFj6C`,
	"noPagination": `LinkItem-module__no-pagination___CPZGJ`,
	"medicalTableEmpty": `LinkItem-module__medical-table-empty___X3rsw`,
	"iconBtn": `LinkItem-module__icon-btn___Nmk4z`,
	"searchIcon": `LinkItem-module__search-icon___CVTqM`,
	"disableSelect": `LinkItem-module__disable-select___Nj33C`,
	"breakWord": `LinkItem-module__break-word___ZDDON`,
	"popupClearBtn": `LinkItem-module__popup-clear-btn___zYApN`,
	"scrollMB20": `LinkItem-module__scroll-m-b-20___rU5zb`,
	"container": `LinkItem-module__container___sdLpr`,
	"icon": `LinkItem-module__icon___crpBB`,
	"title": `LinkItem-module__title___BmZCb`,
	"selected": `LinkItem-module__selected___MdnhW`,
	"dot": `LinkItem-module__dot___fp0FJ`
};
module.exports = ___CSS_LOADER_EXPORT___;
